window.onload = () => {
  const d = new Date();
  let year = d.getFullYear();
  const signNode = document.querySelector(".credits"); //Search the node element for footer > rights reserved.
  const sign = document.createElement("p");
  signNode.appendChild(sign);
  sign.innerHTML = `<span >©${year} CasaManos. Todos los derechos reservados. </span><br><span style="font-size: 10px;">E-commerce desarrollado por <a href="https://lobocreaciones.com/" target="_blank" style="cursor: pointer; color: inherit; text-decoration: none; font-size: 10px;" >Lobo Creaciones.</a></span></p>`;
};
